<template lang="pug">
div.task-point-create-edit.p1
  app-custom-table(
    ref="table"
    :tableData="itemList"
    :tableColumns="tableColumns"
    noPagination
    :selectionMode="false"
  )
</template>

<script>
import CarSelect from './CarSelect';

import { GETTER_PROJECT, GETTER_USER } from '@store/account';
import { mapGetters } from 'vuex';

import _ from 'lodash';
export default {
  name: 'CarRecordDTOS',
  components: {
    CarSelect,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: Array,
    CarRecordDTOS: Array,
    target: Object,
  },
  data() {
    return {
      itemList: [],
      model: {
        objectType: null,
        objectKey: null,
        standardIds: [], // 标准
      },
      rules: {
        objectType: [{ required: true, message: '必填项' }],
        objectKey: [{ required: true, message: '必填项' }],
      },
      showForm: false,
      isAdd: false,
      editIndex: -1,

      // 自定义表格列
      tableColumns: [],
      // 批量删除
      canDeleteBatch: false,
    };
  },
  computed: {
    ...mapGetters({
      project: GETTER_PROJECT,
      user: GETTER_USER,
    }),
    params() {
      return {
        projectId: this.project.id,
      };
    },
  },
  watch: {
    value: 'handleValueChange',
  },
  created() {
    // 初始化
    this.handleValueChange();
    this.initTableColumns();
    this.initFilters();
  },
  methods: {
    handleValueChange() {
      this.itemList = this.value || [];
    },
    handleCarChange(v) {
      //
      let index = -1;
      this.itemList.forEach((item, idx) => {
        if (item.carId === v.carId) {
          index = idx;
        }
      });
      if (index >= 0) {
        this.itemList.splice(index, 1, v);
      } else {
        this.itemList.push(v);
      }
      this.change();
    },
    handleDelete(index) {
      // this.$restful(`DELETE:/ops/inspcontents-item/${this.itemList[index].id}`);
      const item = this.itemList.splice(index, 1)[0];
      if (item?.id) {
        this.$emit('delete-item', item.id);
      }
      this.change();
    },
    handleClickAdd() {
      this.showForm = true;
      this.isAdd = true;
      this.$emit('click-add-item');
    },
    handleEdit(index) {
      this.showForm = true;
      this.isAdd = false;
      this.editIndex = index;
      // this.model = {
      //   ...this.itemList[index],
      // };
      this.model = _.cloneDeep(this.itemList[index]);
      this.$refs.carSelector.show(this.model);
      console.log(this.model);
    },
    async handleSave() {
      console.log(this.model.selections, 'selectedItems');
      this.itemList.splice(this.editIndex, 1, {
        ...this.model,
      });
      this.change();
      this.showForm = false;
      this.isAdd = false;
      this.editIndex = -1;
      this.reset();
    },
    handleCancel() {
      this.showForm = false;
      this.isAdd = false;
      this.reset();
    },
    reset() {
      this.model = {
        name: null,
        resultType: null,
      };
      this.$refs.form?.resetFields();
      this.$refs.form?.clearValidate();
    },
    change() {
      this.$emit('update:pointDTOS', this.itemList);
      this.$emit('change', this.itemList);
    },
    // 批量删除产品
    handleDeleteBatch() {},
    // 初始化表格 列
    initTableColumns() {
      this.tableColumns = [
        {
          uid: 'plate',
          dataIndex: 'plate',
          title: '车牌号码',
          width: '100px',
          customClass: ['pl2'],
          // sorter: true,
        },
        {
          uid: 'driverName',
          dataIndex: 'driverName',
          title: '司机姓名',
          width: '100px',
        },
        {
          uid: 'porterNames',
          dataIndex: 'porterNames',
          title: '搬运工',
          width: 'auto',
          flex: 1,
          render(h, v) {
            return v?.join(',') || '--';
          },
        },
        {
          uid: 'installerNames',
          dataIndex: 'installerNames',
          title: '安装工',
          width: 'auto',
          flex: 1,
          render(h, v) {
            return v?.join(',') || '--';
          },
        },
      ];
    },
    //
    initFilters() {},
  },
};
</script>

<style lang="less" scoped>
.task-point-create-edit {
  // margin-left: -90px;
  // margin-top: -4px;
  // width: calc(100% + 90px);
  .insp-item-list {
    // display: ;
    .insp-item-list-head,
    .insp-item-list-body {
      text-align: center;
      .item-name,
      .item-type,
      .item-config,
      .item-action {
        padding: 8px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        word-break: break-all;
      }
      .item-name {
        flex: 1;
      }
      .item-type {
        flex: 1;
        border-left: 1px solid rgba(0, 0, 0, 0.1);
      }
      .item-config {
        flex: 3;
        border-left: 1px solid rgba(0, 0, 0, 0.1);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .item-action {
        flex: 1;
        border-left: 1px solid rgba(0, 0, 0, 0.1);
      }
    }
    .insp-item-list-head {
      color: rgba(0, 0, 0, 0.85);
      border: 1px solid rgba(0, 0, 0, 0.1);
      background-color: rgba(0, 0, 0, 0.05);
    }
    .insp-item-list-body {
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-top-width: 0;
    }
    .item-row {
      justify-content: stretch;
      & + .item-row {
        border-top: 1px solid rgba(0, 0, 0, 0.1);
      }
    }
  }
  .insp-object {
    .insp-object-name {
      font-size: 16px;
      font-weight: 600;
    }
  }
}
</style>
